import React from 'react';
import BaseComponent from './BaseContainer';
import { graphql, compose, withApollo } from 'react-apollo';
import { Redirect } from 'react-router';
import ServiceForm from '../components/form/Service';
import getService from '../apollo/graphql/service/get';
import getServices from '../apollo/graphql/service/getServices';
import createService from '../apollo/graphql/service/create';
import deleteService from '../apollo/graphql/service/delete';
import updateService from '../apollo/graphql/service/update';
import {
  convertGraphQlToObject,
  convertObjetToGraphQlVariables,
} from '../helpers/contentWithI18n';
import { languages } from '../constants';
import { createTranslationsObject } from '../helpers/translation';

class ServiceContainer extends BaseComponent {
  constructor(props) {
    super(props);

    const isNew =
      props.match.params.objId === 'new' ||
      props.match.params.objId === undefined;

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false },
      },
      redirect: false,
      obj: {
        order: 0,
        translations: createTranslationsObject({
          name: '',
          cta_label: '',
          cta_url: '',
        }),
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client
        .query({
          query: getService,
          variables: { id: this.props.match.params.objId },
        })
        .then(({ data }) => {
          if (getService.error) {
            this.setState({
              status: {
                ...this.state.status,
                error: true,
                message: getService.error.message,
              },
            });
          }

          const newObject = {
            ...this.state.obj,
            ...convertGraphQlToObject(data.getService),
          };
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              loading: false,
            },
            obj: {
              ...this.state.obj,
              ...newObject,
              translations: {
                ...this.state.obj.translations,
                ...newObject.translations,
              },
            },
          });
        });
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false,
        },
      });
    }
  }

  handleChange(Service, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    let dataIsLanguage = false;
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true;
      }
    }
    if (dataIsLanguage) {
      //translations data
      newState.obj.translations[data][Service.target.id] = Service.target.value;
    } else if (type === 'dropdown') {
      //dropdown
      newState.obj[data.id] = data.value;
    } else if (Service.target.files && Service.target.files.length > 0) {
      //files
      newState.obj[Service.target.id] = Service.target.files[0];
    } else {
      //simple data
      newState.obj[Service.target.id] = Service.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
      },
    });
    const obj = convertObjetToGraphQlVariables(this.state.obj);
    if (this.state.status.isNew) {
      let newObj = {
        ...obj,
      };
      this.props
        .createService({
          variables: {
            input: { ...newObj },
          },
        })
        .then((data) => {
          this.setState({ redirect: true });
        })
        .catch((error) => {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              message: error.message,
              error: true,
              isNew: true,
            },
          });
        });
    } else {
      // update object
      let newObj = {
        ...obj,
      };
      const { id } = newObj;
      delete newObj.id;
      delete newObj.updated_at;
      this.props
        .updateService({
          variables: {
            id: id,
            input: { ...newObj },
          },
        })
        .then(({ data, errors }) => {
          if (errors) {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                errors: errors,
              },
            });
          } else {
            this.setState({ redirect: true });
          }
        });
    }
  }

  handleDelete(event, data) {
    event.preventDefault();
    let newState = {
      status: {
        ...this.state.status,
        deletion: {},
      },
    };
    switch (data.confirm) {
      case true:
        newState.status.deletion.confirm = true;
        break;
      case null:
        newState.status.deletion.confirm = false;
        break;
      case false:
        newState.status.deletion.confirm = false;
        this.props
          .deleteService({ variables: { id: this.state.obj.id } })
          .then(this.setState({ redirect: true }))
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
              },
            });
          });
        break;
      default:
        break;
    }
    this.setState(newState);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/services" />;
    }
    if (this.state.status.loading) {
      return <div>Chargement</div>;
    }
    return (
      <ServiceForm
        obj={this.state.obj}
        status={this.state.status}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
      />
    );
  }
}

const ServiceContainerEnhanced = compose(
  graphql(updateService, { name: 'updateService' }),
  graphql(createService, { name: 'createService' }),
  graphql(deleteService, {
    name: 'deleteService',
    options: {
      update: (proxy, { data }) => {
        const services = proxy.readQuery({ query: getServices });
        services.getServices = services.getServices.filter(
          (obj) => obj.id !== data.deleteService.id,
        );
        proxy.writeQuery({ query: getServices, data: services });
      },
    },
  }),
)(ServiceContainer);

export default withApollo(ServiceContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/ServiceContainer.js